import React from 'react';
import { Moon, Sun } from 'lucide-react';
import { useTheme } from '../context/ThemeContext';

export const ThemeToggle = () => {
  const { isDark, lightOnly, toggle } = useTheme();
  if (lightOnly) return null;
  return (
    <button
      type="button"
      onClick={toggle}
      aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
      title={isDark ? 'Light mode' : 'Dark mode'}
      className="fixed bottom-4 left-4 z-40 h-9 w-9 rounded-full flex items-center justify-center shadow-md border transition-colors duration-200 bg-white border-slate-200 text-slate-600 hover:bg-slate-100"
      data-testid="theme-toggle"
    >
      {isDark ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
    </button>
  );
};

export default ThemeToggle;
